import React from "react";

const Modal = () => {
  var modal = document.getElementById("myModal");

  let closeModal = () => {
    modal.style.display = "none";
  };
  let displayModal = () => {
    modal = document.getElementById("myModal");
    modal.style.display = "block";
  };
  window.onclick = function (event) {
    if (event.target === modal) {
      modal.style.display = "none";
    }
  };
  return (
    <React.Fragment>
      <div>
        <button className="infoBtn" onClick={displayModal}>
          <i className="fa fa-info-circle infoIcon"></i>
        </button>
      </div>
      <div id="myModal" className="modal">
        <div className="modal-content">
          <span className="close" onClick={closeModal}>
            &times;
          </span>
          <h1 style={{ color: "black" }}>Instruction</h1>
          <p className="info">
            Please "Allow Camera Permission" to play the game interactively.
          </p>
          <p className="info">
            Then play your game by showing your hand either rock, paper or
            scissor facing to web camera.
          </p>
          <p className="info">
            Then camera will capture the image within few seconds and score will
            be updated.
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Modal;
